import { FC, ReactNode } from "react";
import Footer from "../../Containers/Footer";
import Header from "../../Containers/Header";
import Alert from "../../Components/AlertPopup";
import { useNavigate } from "react-router-dom";

interface StateProps {
  children: ReactNode;
  show?: boolean;
}

const PageContainer: FC<StateProps> = ({ children, show }) => {
  const navigate = useNavigate();
  const sessionExpired = sessionStorage.getItem("sessionExpired") === "true";
  return (
    <div className="App">
      <Header />
      <div className="appPage">
        <div className="pageContainer">{children}</div>
      </div>
      <br />
      <br />
      <br />
      <Footer show={show} />
      {(sessionExpired) && (
        <Alert
          type="error"
          show={true}
          message="Session has expired. Please log in again."
          onClose={() => {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("sessionExpired");
            navigate("/login"); // Redirect only after closing
          }}
        />
      )}
    </div>
  );
};

export default PageContainer;
